import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductList from '../../components/DynamicListGrid/DynamicListGrid';
import {getStoredData} from "../../JsonFiles/fetchData";
import { useNavigate } from 'react-router-dom';

const AdminProjects = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminProjects : {};

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/projects');
        setProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching actvities:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <p>Loading projects...</p>;
  }

  return (
    <div className="admin-products">
      <h2>Projects List</h2>
      <button onClick={() => navigate('/admin/add-projects')}>
        Create New Projects
      </button>
      <ProductList products={products} fields={fields} redirect={totalData[12].AdminProjectsEdit} deleteApi="https://shahbad-enterprises-backend.vercel.app/projects"/>
    </div>
  );
};

export default AdminProjects;

